// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2a4zE","load3":"Spinner_load3__32B6x"};